import * as React from "react";
import { forwardRef } from "react";
const SvgComponent = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", Object.assign({
  viewBox: "0 0 24 25",
  fill: "currentColor",
  "aria-hidden": "true",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M16.074 7.915a.75.75 0 0 1 .956.721v9.758a.8.8 0 0 1-.025.182 2.47 2.47 0 0 1-2.446 2.138 2.473 2.473 0 1 1 .972-4.747v-3.468l-6.536 1.868v6.246a2.473 2.473 0 1 1-1.5-2.275v-7.407a.75.75 0 0 1 .544-.721l8.036-2.296zM6.522 19.642a.973.973 0 1 0 .002 1.946.973.973 0 0 0-.002-1.946m8.037-2.373a.97.97 0 0 0-.972.972.973.973 0 0 0 1.944.012v-.028a.97.97 0 0 0-.972-.955zm-5.564-5.771v1.311l6.536-1.867V9.629z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M4.613 13.476a.75.75 0 0 1 .66 1.345l-1.608.895a.75.75 0 0 1-1.02-.29.75.75 0 0 1 .29-1.019l1.609-.896.068-.034zm14.205-.08a.75.75 0 0 1 .991-.374l1.679.757.068.034a.75.75 0 0 1-.686 1.332l-1.679-.757a.75.75 0 0 1-.374-.992zM2.854 9.039a.75.75 0 0 1 .984-.393l1.692.727.068.033a.75.75 0 0 1-.661 1.345l-1.691-.728a.75.75 0 0 1-.393-.984zm17.742-1.098a.75.75 0 0 1 .985.393.75.75 0 0 1-.392.984l-1.692.728a.75.75 0 0 1-.661-1.345l.068-.033zM5.848 4.776a.75.75 0 0 1 1.058-.074l1.39 1.208.056.053a.75.75 0 0 1-.978 1.127l-.062-.047-1.39-1.208a.75.75 0 0 1-.074-1.059m11.118-.789a.75.75 0 1 1 1.133.983L16.89 6.36a.75.75 0 0 1-1.132-.984zm-4.885-1.835a.75.75 0 0 1 .801.695l.129 1.837a.75.75 0 0 1-.695.801.75.75 0 0 1-.801-.695l-.129-1.837a.75.75 0 0 1 .695-.801"
}));
const ForwardRef = forwardRef(SvgComponent);
export const MusicNoteRadiatingIcon = ForwardRef;